/**
 * Screentone / halftone pattern definitions.
 * Each pattern is rendered as an SVG pattern inside a <defs> block.
 */

export const SCREENTONE_PATTERNS = [
  {
    key: "none",
    label: "None",
    svg: null,
  },
  {
    key: "dots",
    label: "Halftone Dots",
    patternSize: 8,
    svg: (size) => `<circle cx="${size / 2}" cy="${size / 2}" r="${size / 4}" fill="currentColor"/>`,
  },
  {
    key: "crosshatch",
    label: "Crosshatch",
    patternSize: 10,
    svg: (size) =>
      `<line x1="0" y1="0" x2="${size}" y2="${size}" stroke="currentColor" stroke-width="0.5"/>` +
      `<line x1="${size}" y1="0" x2="0" y2="${size}" stroke="currentColor" stroke-width="0.5"/>`,
  },
  {
    key: "stipple",
    label: "Stipple",
    patternSize: 6,
    svg: (size) =>
      `<circle cx="${size * 0.25}" cy="${size * 0.25}" r="0.6" fill="currentColor"/>` +
      `<circle cx="${size * 0.75}" cy="${size * 0.75}" r="0.6" fill="currentColor"/>`,
  },
  {
    key: "lines_h",
    label: "Horizontal Lines",
    patternSize: 6,
    svg: (size) => `<line x1="0" y1="${size / 2}" x2="${size}" y2="${size / 2}" stroke="currentColor" stroke-width="0.5"/>`,
  },
  {
    key: "lines_v",
    label: "Vertical Lines",
    patternSize: 6,
    svg: (size) => `<line x1="${size / 2}" y1="0" x2="${size / 2}" y2="${size}" stroke="currentColor" stroke-width="0.5"/>`,
  },
  {
    key: "lines_diag",
    label: "Diagonal Lines",
    patternSize: 8,
    svg: (size) => `<line x1="0" y1="${size}" x2="${size}" y2="0" stroke="currentColor" stroke-width="0.5"/>`,
  },
  {
    key: "speed_lines",
    label: "Speed Lines",
    patternSize: 12,
    svg: (size) =>
      `<line x1="0" y1="${size * 0.3}" x2="${size}" y2="${size * 0.3}" stroke="currentColor" stroke-width="0.3"/>` +
      `<line x1="0" y1="${size * 0.7}" x2="${size}" y2="${size * 0.7}" stroke="currentColor" stroke-width="0.8"/>`,
  },
];

export const findScreentone = (key) => {
  return SCREENTONE_PATTERNS.find((p) => p.key === key) || SCREENTONE_PATTERNS[0];
};
